export const waitForFrame = async() => new Promise(resolve => {
  requestAnimationFrame(resolve);
});

export const waitForTimeout = async(length = 0) => new Promise(resolve => {
  setTimeout(resolve, length);
});

export async function waitForTicks(count = 1) {
  await Promise.all(
    Array(count).fill(null).map(
      async() => {
        await this.$nextTick;
      }
    )
  );
}
